import axioss from "axios";
import getHeaders from "./headers";
import { apiUrl } from "./apiUtils";
import environment from '../environment';

let xmlFile = require("../assets/car.xml");

const axios = axioss.create({
  timeout: 1000 * 60 * 15,
});
export default axios;

const { baseUrl, auctionExperienceApi, remktExperienceApi, issuerUrl, clientS, accessTokenClientS } = environment.prod;

export function handleResponse(response) {
  if (response.status !== 404) {
    return response;
  }
}

export const apiRequest = async (url, requestData, options) => {
    return await apiRequest(url, requestData, options);
}

export const apiDataRequest = (config, okta = false) => {
  if(!okta) {
    config.url = `${baseUrl}${auctionExperienceApi}${config.url}`
  }

  return axios(config)
}
export const remktapiDataRequest = (config, okta = false) => {
  if(!okta) {
    config.url = `${baseUrl}${remktExperienceApi}${config.url}`
  }

  return axios(config)
}

export async function getAuthToken() {
  const options = {
    headers: {
      "content-type": "application/x-www-form-urlencoded",
    },
  };
  const requestData = {
    grant_type: "client_credentials",
    client_id: "0oaxox9wq1633Vljm0h7",
    client_secret: accessTokenClientS,
  };

  return await apiRequest(apiUrl.tokenUrl, requestData, options);
}

export async function getVehicleDetails(token, VINumber) {
  const options = {
    headers: {
      Authorization: token,
    },
  };
  const requestData = {
    LookupKey: "FullVINOnly",
    //"LookupValue": "JM3KFBDM0K1698372"
    LookupValue: VINumber,
  };
    return await apiRequest(apiUrl.url, requestData, options);
}
export async function getGroundingList(index) {
  if (index === undefined) {
    index = '1';
  }
  let stringData = localStorage.getItem("selectedDealersNumber");
  console.log(stringData)
  let payload = ["ALL"];
  if (stringData?.length >= 0) {
    payload = stringData?.split(',')
  };
  var data = payload;

  var config = {
    method: "post",
    url: `${apiUrl.groundListUrl}?pageNumber=${index}`,
    headers: getHeaders(),
    data: data,
  };

  return await apiDataRequest(config);
}

export async function getPassedList(index) {
  let stringData = localStorage.getItem("selectedDealersNumber");
  let payload = ["ALL"];
  if (stringData?.length >= 0) {
    payload = stringData?.split(',')
  };
  var data = payload;
  if (index === undefined) {
    index = '1';
  }
  var config = {
    method: "post",
    url: `${apiUrl.passedVehicleUrl}?pageNumber=${index}`,
    headers: getHeaders(),
    data: data,
  };
  
  return await apiDataRequest(config);
}

export async function getPassedList1() {
  const options = {
    headers: getHeaders(),
  };
  const requestData = "ALL";

  return await apiRequest(apiUrl.passedVehicleUrl, requestData, options);
}
export async function getPurchasedList(index) {
  let stringData = localStorage.getItem("selectedDealersNumber");
  let payload = ["ALL"];
  if (stringData?.length >= 0) {
    payload = stringData?.split(',')
  };
  var data = payload;
  if (index === undefined) {
    index = '1';
  }
  var config = {
    method: "post",
    url: `${apiUrl.purchasedVehicleUrl}?pageNumber=${index}`,
    headers: getHeaders(),
    data: data,
  };

  return await apiDataRequest(config);
}

export async function getInspectionVehicleDetails(vin,groundingId) {
  var config = {
    method: "post",
    url: groundingId ? apiUrl.inspectionVehicleDetails.concat(`?groundingId= ${groundingId}`) : apiUrl.inspectionVehicleDetails,
    headers: getHeaders(),
    data: {
      vin
    },
  };
  console.log(config);
  return await apiDataRequest(config);
}

export async function postGroudingLite(payload) {
  var config = {
    method: "post",
    url: apiUrl.groundingLite,
    headers: getHeaders(),
    data: payload,
  };
  return await apiDataRequest(config);
}

export async function getInspectionWheelTiresDetails(inspectionId) {
  var data = JSON.stringify(inspectionId);

  var config = {
    method: "post",
    url: apiUrl.inspectionWheelTiresDetailsUrl,
    headers: getHeaders(),
    data: data,
  };
  return await apiDataRequest(config);
}

export async function getInspectionAccessoryDetails(vin) {
  var config = {
    method: "post",
    url: apiUrl.inspectionAccessoryDetailsUrl,
    headers: getHeaders(),
    data: {
      vin
    }
  };
  return await apiDataRequest(config);
}
export async function getInspectionDamageDetailsApi(inspectionId, vin) {
    const data = {
      vin,
      inspectionId,
    }
  var config = {
    method: "post",
    url: apiUrl.getInspectionDamageDetailsUrl,
    headers: getHeaders(),
    data
  };
  return await apiDataRequest(config);
}
export async function getOEMBuildDetailsApi(vin) {
  var config = {
    method: "post",
    url: apiUrl.getOEMBuildDetailsUrl,
    headers: getHeaders(),
    data: vin,
  };
  return await apiDataRequest(config);
}
export async function postDealerActionPassOnVehicle(vin, groundingId) {
  const data = {
    groundingId,
    vin,
    dealerAction:"Pass"
  }
  var config = {
    method: "post",
    url: apiUrl.getDealerActionUrl,
    headers: getHeaders(),
    data
  };
  return await apiDataRequest(config);
}
export async function postDealerActionPurchaseOnVehicle(vin, groundId) {
  const data = {
    vin,
    groundId,
    dealerAction:'Purchase'
  }
  var config = {
    method: "post",
    url: apiUrl.getDealerActionUrl,
    headers: getHeaders(),
    data
  };
  return await apiDataRequest(config);
}
export async function awaitManualPricing() {

  var config = {
    method: "get",
    url: apiUrl.AMP,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}
export async function RRMList() {
  var config = {
    method: "post",
    url: apiUrl.rrm,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}
export async function getMileageDiscList() {
  var config = {
    method: "get",
    url: apiUrl.mileageDiscList,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

var qs = require("qs");
export async function getAccessTokenEndpoint(code) {
  var data = qs.stringify({
    grant_type: "authorization_code",
    client_id: apiUrl.clientID,
    code: code,
    client_secret: clientS,
    redirect_uri: apiUrl.redirectURL,
    // redirect_uri: "http://localhost:3000/login2",
  });
  var config = {
    method: "post",
    url: apiUrl.TokenURI,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      //   Cookie:
      //     "BrowserId=LAkGcCGXEeyO6WviLU7-xw; CookieConsentPolicy=0:1; LSKey-c$CookieConsentPolicy=0:1",
    },
    data: data,
  };

  return await apiDataRequest(config);
}
export async function getRefreshTokenEndpoint() {
  var data = qs.stringify({
    grant_type: "refresh_token",
    client_id: apiUrl.clientID,
    refresh_token: localStorage.getItem("refreshToken"),
    client_secret: clientS,
    redirect_uri: apiUrl.redirectURL,
    // redirect_uri: "http://localhost:3000/login2",
  });
  var config = {
    method: "post",
    url: apiUrl.TokenURI,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      //   Cookie:
      //     "BrowserId=LAkGcCGXEeyO6WviLU7-xw; CookieConsentPolicy=0:1; LSKey-c$CookieConsentPolicy=0:1",
    },
    data: data,
  };

  return await apiDataRequest(config);
}
// export async function getUserInfoToken(token) {
//   var qs = require("qs");
//   var config = {
//     method: "post",
//     url: `https://stratus-stg3.mfindealerservices.com/services/oauth2/userinfo?access_token=${token}`,
//   };

//   return await apiDataRequest(config);
// }
export async function getForgeRockToken() {
  var config = {
    method: "get",
    url: apiUrl.ForgeRockTokenURI,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("bearerToken")}`,
      Cookie: "CookieConsentPolicy=0:1; LSKey-c$CookieConsentPolicy=0:1",
    },
  };
  return await apiDataRequest(config);
}

export async function getOktaUserInfo() {
  var config = {
    method: 'get',
    url: `${issuerUrl}${apiUrl.oktaUserURL}`,
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${localStorage.getItem("okta_access_token")}`,
      'Cookie': 'DT=DI04xgdsdpbT-6S2joEtp5Bdg'
    },
  };
  const okta = true;
  return await apiDataRequest(config, okta);
}

export async function getImageData(obj) {
  // let data = {
  //   "inspectionId": 18495852,
  //   "paramForImage": "All",
  //   "tenantId": "t002"
  // };
  var config = {
    method: "post",
    url: apiUrl.getImages,
    headers: getHeaders(),
    data: obj,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getCarXml() {
  return await axios(xmlFile.default).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getDealerPaymentsData(KintoId) {

  const { baseUrl, auctionExperienceApi } = environment.prod;

  const options = {
    headers: getHeaders(),
  };
  const dealerPayment = `${baseUrl}${auctionExperienceApi}${apiUrl.getDealerPayments}?KintoId=${KintoId}`;
  return await axios.get(dealerPayment, options);
}
export async function getHealthCheckDetails()
{
  var config = {
    method: "get",
    url: apiUrl.healthCheckURI,
    headers: getHeaders(),
  };
  return await remktapiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}
export async function getPurchaseDetails(groundingId) {
  var config = {
    method: "post",
    url: apiUrl.getPurchaseDetailsApi,
    headers: getHeaders(),
    data: groundingId,
  };
  console.log(config);
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getTransportationDetails(vinlist) {
  var config = {
    method: "post",
    url: apiUrl.transportDetails,
    headers: getHeaders(),
    data: vinlist
  };

  return await apiDataRequest(config);
}

export async function getDealerDropData() {

  var config = {
    method: "post",
    url: apiUrl.dealerDrop,
    headers: getHeaders(),
  };

  return await apiDataRequest(config);
}
export async function manageUserData(manageUserPayload) {
  try {
    var config = {
      method: "post",
      url: apiUrl.manageUser,
      headers: getHeaders(),
      data: manageUserPayload,
    };

    return await apiDataRequest(config);
  } catch (err) {
    console.log("Error-manageUserData", err.message)
    return null
  }
}
export async function onSubmitPayment(data) {
  var config = {
    method: "post",
    url: apiUrl.submitPayment,
    headers: getHeaders(),
    data: data,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getDealerVehicleCount() {
  let stringData = localStorage.getItem("selectedDealersNumber");
  let payload = ["ALL"];
  if (stringData?.length >= 0) {
    payload = stringData?.split(',')
  };
  var data = payload;
  console.log(payload);

  var config = {
    method: "post",
    url: apiUrl.dealerVehicleCount,
    headers: getHeaders(),
    data: data,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getGroundingDetailsByVin(vin, groundingId) {
  var config = {
    method: "post",
    url: groundingId ? apiUrl.getGroundingDetailsURI.concat(`?groundingId= ${groundingId}`) : apiUrl.getGroundingDetailsURI,
    headers: getHeaders(),
    data: vin,
  };
  try {
    return await apiDataRequest(config).then(
      (res) => {
        return handleResponse(res)
      }
    );
  } catch (error) {
    console.log(error)
  }
}

export async function getVehicleSaleInfoByVin(vin,groundingId) {
  var config = {
    method: "post",
    url: groundingId ? apiUrl.getVehicleSaleInfoURI.concat(`?groundingId= ${groundingId}`) : apiUrl.getVehicleSaleInfoURI,
    headers: getHeaders(),
    data: {
      vin
    }
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getNotes(vin) {
  var config = {
    method: "post",
    url: apiUrl.getNotesURI,
    headers: getHeaders(),
    data: {
      vin
    }
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function insertNotes({ vin, notes }) {
  const data = {
    vin,
    notes
  }
  var config = {
    method: "post",
    url: apiUrl.insertNotesURI,
    headers: getHeaders(),
    data
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getVehicalStatusHistory(vin) {
  var config = {
    method: "post",
    url: apiUrl.getVehicleStatusHistoryURI,
    headers: getHeaders(),
    data: {
      vin
    }
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function updateMileage(body) {
  var config = {
    method: "post",
    url: apiUrl.updateMileageURI,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}
// http://localhost:8083/asp-services/updatePricingHistory?
// priceMethod=Manual&providerName=Test%20User&vehicle_price=27000&vin=JM3KFBCM6M0494704
export async function updatePricingHistory({
  priceMethod,
  providerName,
  vehicle_price,
  MMR,
  vin,
  pageName = ""
}) {
  let body;
  if (pageName === 'RRMApproval') {
    let nameInfo= localStorage.getItem('userName') || "test user";
    body = {
      "approvedBy": nameInfo,
      "mmr_price": MMR,
      "userName": nameInfo,
      "vehicle_price": vehicle_price,
      "vin": vin
    }

  }
  else {
    let nameInfo= localStorage.getItem('userName') || "test user";
    body = {
      "mmr_price": MMR,
      "userName": nameInfo,
      "vehicle_price": vehicle_price,
      "vin": vin
    }
  }

  var config = {
    method: "post",
    url: apiUrl.updatePricingHistoryURI,
    headers: getHeaders(),
    data: body
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}


export async function getClearfaxStatusByVin(vin) {
  var config = {
    method: "post",
    url: apiUrl.getCarfaxStatusURI,
    headers: getHeaders(),
    data: vin,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getPricingHistoryByVin(vin) {
  var config = {
    method: "post",
    url: apiUrl.getPricingHistory,
    headers: getHeaders(),
    data: {
      vin
    }
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function updateRRMactionPrice(body) {
  var config = {
    method: "post",
    url: apiUrl.updateRRMPrice,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );

}

export async function getReasonForUpdateMileage() {
  var config = {
    method: "post",
    url: apiUrl.getReasonForUpdateMileageUrl,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

export async function getReasonsForUngrounding() {
  var config = {
    method: "get",
    url: apiUrl.getUngroundingReason,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

export async function getUngroundingDetailByVIN(ungroundingDetailByVinRequest) {
  var config = {
    method: "post",
    url: apiUrl.getUngroundingDetailByVIN,
    headers: getHeaders(),
    data: ungroundingDetailByVinRequest,
  };
  return await apiDataRequest(config);
}

export async function submitUngroundingRequest(ungroundingRequest) {
  var config = {
    method: "post",
    url: apiUrl.submitUnground,
    headers: getHeaders(),
    data: ungroundingRequest,
  };
  return await apiDataRequest(config);
}



export async function getAdminSettings() {
  var config = {
    method: "get",
    url: apiUrl.adminSettings,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

export async function updateAdminSettings(body) {
  var config = {
    method: "post",
    url: apiUrl.adminSettings,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function getPurchaseReceipt(vin, groundingId) {
  var config = {
    method: "post",
    url: groundingId ? apiUrl.purchaseReceipt.concat(`?groundingId= ${groundingId}`) : apiUrl.purchaseReceipt,
    headers: getHeaders(),
    data: vin,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getDealerProviderSettings() {
  var config = {
    method: "get",
    url: apiUrl.dealerDefaults,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

export async function updateDealerProviderSettings(body) {
  var config = {
    method: "post",
    url: apiUrl.dealerDefaults,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}


export async function getArbitrationList() {
  var config = {
    method: "post",
    url: apiUrl.arbitrationList,
    headers: getHeaders(),
  };
  return await apiDataRequest(config);
}

export async function arbitrationReview(body) {
  var config = {
    method: "post",
    url: apiUrl.arbitrationReview,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function arbitrationAdminStatusHistory(body) {
  var config = {
    method: "post",
    url: apiUrl.arbitrationAdminStatusHistory,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function arbitrationStatusUpdateApi(body) {
  var config = {
    method: "post",
    url: apiUrl.arbitrationStatusUpdate,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function authAdminUpdate(body) {
  var config = {
    method: "post",
    url: apiUrl.authAdmin,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function getExtractionList(body) {
  var config = {
    method: "post",
    url: apiUrl.extractList,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}
 
export async function getExtract(body) {
  var config = {
    method: "post",
    url: apiUrl.extract,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config).then(
    (res) => {
      return res;
    },
    (err) => {
      console.log(err);
    }
  );
}

export async function getAdminSettingsList(body) {
  var config = {
    method: "post",
    url: apiUrl.adminSettingsList,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function updateAdminSettingsApi(body) {
  var config = {
    method: "post",
    url: apiUrl.adminSettingsAPI,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function getEventsList(body) {
  var config = {
    method: "post",
    url: apiUrl.eventsList,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}

export async function updateEvents(body) {
  var config = {
    method: "post",
    url: apiUrl.events,
    headers: getHeaders(),
    data: body,
  };
  return await apiDataRequest(config);
}
